export abstract class CurrencyHelper {
  private static currencySymbols = {
    USD: '$', // US Dollar
    EUR: '€', // Euro
    GBP: '£', // British Pound Sterling
    CAD: 'C$', // Canadian Dollar
    ZAR: 'R', // South African Rand
    JPY: '¥', // Japanese Yen
    NAD: 'N$', // Namibian Dollar
    CNY: '¥', // Chinese Yuan
  };

  static isoCodes(): string[] {
    return Object.keys(this.currencySymbols);
  }

  static symbols(): string[] {
    return Object.values(this.currencySymbols);
  }

  static getCode(symbol: string) {
    return Object.keys(this.currencySymbols).find(
      (key) => this.currencySymbols[key] === symbol,
    );
  }

  static getSymbol(code: string) {
    return this.currencySymbols[code];
  }

  static getCurrencies(): { isoCode: string; symbol: string }[] {
    return Object.entries(this.currencySymbols).map((kvp) => {
      return { isoCode: kvp[0], symbol: kvp[1] };
    });
  }
}
